import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect, useSelector } from 'react-redux';
import { SegmentContext } from './Context';
import { ConnectedFlightsManagerLegMobile } from '../../FlightsManagerLegMobile';
import { DateFieldRoundTrip } from '../../MobileFields/DateFieldRoundTrip';
import { SearchSegment, TripType } from '../../../../models';
import { getSegments, displayFaresInCalendar, isTrainsProductActive } from '../../../../redux/currentSearch/selectors';
import { ConnectedFaresProvider } from '../../../../components/Calendar/Context/FaresProvider';
import { PaxSelectorMobile } from '../../../PaxSelector';
import { RoomSelector } from '../../../RoomSelector/RoomSelectorMobile';
import { Box } from '../../../../layouts';
import { Config, isTrainsRoundTripDiscountCard } from '../../../../utils';

export const SegmentManagerRoundTripContent = ({ segments, displayFaresInCalendar }) => {
    const isTrainsProduct = useSelector(isTrainsProductActive);
    const segment = segments[0];

    if (!segment) {
        return null;
    }

    const isDp = Config.get('isDp') || Config.get('entryPoint') === 'dp';
    const isRailsRoundTripDiscountCard = !isDp && isTrainsRoundTripDiscountCard({
        isTrainsProduct,
        tripType: TripType.ROUND_TRIP,
    });

    return (
        <SegmentContext.Provider value={{ segment }}>
            <ConnectedFlightsManagerLegMobile index={0} />
            <Box display="flex" flexDirection="row">
                <Box flex={isRailsRoundTripDiscountCard ? '0 0 100%' : '0 0 65%'} marginRight={isRailsRoundTripDiscountCard ? undefined : '8px'}>
                    <ConnectedFaresProvider
                        segmentId={segment.id}
                        displayFaresInCalendar={displayFaresInCalendar}
                    >
                        <DateFieldRoundTrip />
                    </ConnectedFaresProvider>
                </Box>
                {!isRailsRoundTripDiscountCard && (
                    <Box flex="0 0 calc(35% - 8px)">
                        { !isDp ? <PaxSelectorMobile isHotelOptionEnabled={false} /> : <RoomSelector /> }
                    </Box>
                )}
            </Box>
        </SegmentContext.Provider>
    );
};


SegmentManagerRoundTripContent.propTypes = {
    segments: PropTypes.arrayOf(SearchSegment),
    displayFaresInCalendar: PropTypes.bool,
};

SegmentManagerRoundTripContent.defaultProps = {
    segments: [],
    displayFaresInCalendar: false,
};

export const SegmentManagerRoundTrip = ({ segments, displayFaresInCalendar }) => {
    return (
        <React.Fragment>
            <SegmentManagerRoundTripContent
                segments={segments}
                displayFaresInCalendar={displayFaresInCalendar}
            />
        </React.Fragment>
    );
};

SegmentManagerRoundTrip.propTypes = {
    segments: PropTypes.arrayOf(SearchSegment),
    displayFaresInCalendar: PropTypes.bool,
};

SegmentManagerRoundTrip.defaultProps = {
    segments: [],
    displayFaresInCalendar: false,
};

const mapStateToPropsSelector = createStructuredSelector({
    segments: getSegments,
    displayFaresInCalendar: displayFaresInCalendar,
});

export const ConnectedSegmentManagerRoundTrip = connect(mapStateToPropsSelector)(
    SegmentManagerRoundTrip,
);
